import { render, staticRenderFns } from "./MyQuizzesGameCategoryModal.vue?vue&type=template&id=9a35cc4a&scoped=true&"
import script from "./MyQuizzesGameCategoryModal.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesGameCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a35cc4a",
  null
  
)

export default component.exports